export default __webpack_public_path__ + "static/media/uStates.3b699bd3.svg";